import { render, staticRenderFns } from "./ChatHistory.vue?vue&type=template&id=85b2d1f0"
import script from "./ChatHistory.vue?vue&type=script&lang=js"
export * from "./ChatHistory.vue?vue&type=script&lang=js"
import style0 from "./ChatHistory.vue?vue&type=style&index=0&id=85b2d1f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports